import { useFetchLocationsCached } from '@/hooks/queries/use-locations.query';
import i18n from '@/lib/i18n/i18n';
import { notify } from '@/ui/snackbar/notify';

import { mapCompanyLocationOption } from '../helpers/map-company-location-option';

export const useCompanyHeadquarterLocationOptions = () => {
  const fetchLocationsCached = useFetchLocationsCached();

  const setOptions = async (search: string) => {
    try {
      const response = await fetchLocationsCached({
        ...(search && { search }),
        type: ['city'],
      });

      return response.map(mapCompanyLocationOption);
    } catch {
      notify({
        message: i18n.t`default:unknownError`,
      });
      return [];
    }
  };

  return { setOptions };
};
